import React, { useState } from 'react';
import { testEmail } from '../../services/api';
import { toast } from 'react-toastify';

const EmailTestComponent = () => {
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('Test Email from CarCare API');
    const [body, setBody] = useState('<h2>Test Email</h2><p>This is a test email sent from the CarCare Admin Panel.</p><p>If you received this email, the SMTP configuration is working correctly.</p>');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email || !email.includes('@')) {
            toast.error('Please enter a valid email address');
            return;
        }

        setLoading(true);
        try {
            const response = await testEmail({
                toEmail: email,
                subject: subject,
                body: body
            });
            
            toast.success('Test email sent successfully!');
            // Reset form
            setEmail('');
            setSubject('Test Email from CarCare API');
            setBody('<h2>Test Email</h2><p>This is a test email sent from the CarCare Admin Panel.</p><p>If you received this email, the SMTP configuration is working correctly.</p>');
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to send test email';
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Test Email</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                        <li className="breadcrumb-item active">Test Email</li>
                    </ol>
                </nav>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Send Test Email</h5>
                                <p className="text-muted">Use this form to test the SMTP email configuration.</p>

                                <form onSubmit={handleSubmit}>
                                    <div className="row mb-3">
                                        <label htmlFor="email" className="col-sm-2 col-form-label">To Email *</label>
                                        <div className="col-sm-10">
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="Enter email address"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label htmlFor="subject" className="col-sm-2 col-form-label">Subject</label>
                                        <div className="col-sm-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="subject"
                                                value={subject}
                                                onChange={(e) => setSubject(e.target.value)}
                                                placeholder="Email subject"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <label htmlFor="body" className="col-sm-2 col-form-label">Body</label>
                                        <div className="col-sm-10">
                                            <textarea
                                                className="form-control"
                                                id="body"
                                                rows="10"
                                                value={body}
                                                onChange={(e) => setBody(e.target.value)}
                                                placeholder="Email body (HTML supported)"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-10 offset-sm-2">
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Sending...
                                                    </>
                                                ) : (
                                                    'Send Test Email'
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default EmailTestComponent;





